/* eslint-disable react-hooks/exhaustive-deps */
import { isoDateFormat } from "common/dateFormatterConfig";
import ElectricityConsumptionSearchBar from "pages/electricity-consumption/components/ElectricityConsumptionSearchBar";
import { MeteringPoint, MeteringPointMeasurementResolution, MeteringPointMeasurements, MeteringPointMeasurementsDataPoint } from "models/electricity/metering-point";
import { DatePeriod, DATE_PRESET_OPTIONS } from "models/calendar";
import React, { useContext, useEffect, useState } from "react";
import { AuthenticationContext } from "services/context/authentication.context";
import MeteringPointService from "services/electricity/metering-point.service";
import ElectricityConsumptionSummary from "pages/electricity-consumption/components/ElectricityConsumptionSummary";
import ElectricityConsumptionChart from "pages/electricity-consumption/components/ElectricityConsumptionChart";
import { PageProps } from "models/page";
import { IOptions } from "common/reactSelectModels";
import { DateRangeInput } from "components/DateRangePicker/DateRangePicker";
import moment from "moment";

export function ElectricityConsumption(props: PageProps) {

    const [loading, setLoading] = useState(true);
    const [meteringPoints, setMeteringPoints] = useState<MeteringPoint[]>([]);
    const [measurementData, setMeasurementData] = useState<MeteringPointMeasurements>();
    const [period, setPeriod] = useState<DatePeriod | DateRangeInput>(DATE_PRESET_OPTIONS[0]);
    const [selectedMeteringPoint, setSelectedMeteringPoint] = useState<IOptions | undefined>();

    const { state } = useContext(AuthenticationContext);

    useEffect(() => {
        props.onLoadValidatePage();
    }, []);

    useEffect(() => {
        fetchMeteringPoints();
    }, [state.customerId]);

    useEffect(() => {
        fetchMeteringPointMeasurements(period.startDate, period.endDate);
    }, [period, selectedMeteringPoint]);

    const fetchMeteringPoints = () => {
        MeteringPointService.getCustomerMeteringPoints(
            state.customerId!
        ).then(res => {
            setMeteringPoints(res.meteringPoints);
            const mp = res.meteringPoints[0];
            setSelectedMeteringPoint({ value: mp.id, label: mp.address + ' (' + mp.eic + ')' });
        })
    }

    const fetchMeteringPointMeasurements = (startDate: moment.Moment, endDate: moment.Moment, resolution?: MeteringPointMeasurementResolution) => {
        if (!selectedMeteringPoint?.value || (!startDate && !endDate)) {
            return;
        }
        setLoading(true);
        MeteringPointService.getCustomerMeteringPointMeasurements(
            state.customerId!,
            selectedMeteringPoint!.value as number,
            startDate.format(isoDateFormat),
            endDate.format(isoDateFormat),
            resolution
        ).then(res => setMeasurementData(res))
        .finally(() => setLoading(false));
    }

    const onDataPointClick = (dataPoint: MeteringPointMeasurementsDataPoint) => {
        if (measurementData?.resolution === MeteringPointMeasurementResolution.HOUR) {
            return;
        }
        if (measurementData?.resolution === MeteringPointMeasurementResolution.MONTH) {
            const startDate = moment(dataPoint.time).startOf('month');
            const endDate = moment(dataPoint.time).endOf('month').endOf('day');
            setPeriod({
                startDate,
                endDate,
                selectedOptionId: null
            });
            fetchMeteringPointMeasurements(startDate, endDate, MeteringPointMeasurementResolution.DAY);
        } else {
            const startDate = moment(dataPoint.time).startOf('day');
            const endDate = moment(dataPoint.time).endOf('day');
            setPeriod({
                startDate,
                endDate,
                selectedOptionId: null
            });
            fetchMeteringPointMeasurements(startDate, endDate, MeteringPointMeasurementResolution.HOUR);
        }
    }

    return (
        <div className="electricity-consumption__container">
            <ElectricityConsumptionSearchBar
                period={period}
                setPeriod={setPeriod}
                selectedMeteringPoint={selectedMeteringPoint}
                setSelectedMeteringPoint={setSelectedMeteringPoint}
                meteringPoints={meteringPoints}
            />
            <ElectricityConsumptionSummary
                measurementData={measurementData}
                loading={loading}
            />
            <div className="mt-4">
                <ElectricityConsumptionChart
                    measurementData={measurementData}
                    loading={loading}
                    onDataPointClick={onDataPointClick}
                />
            </div>
        </div>
        
    )
}